export const wapLink = 'https://wap-mesa-regalos.sears.com.mx/';
